import { useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Create from '@mui/icons-material/Create';
import { getAbout, getUsersAdmin } from '../utils/api';
import Loading from './loading';
import AboutModal from './about-modal';

const About = () => {
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
  const [isAdmin, setIsAdmin] = useState(false);
  const [xml, setXml] = useState(null);
  const [showAboutModal, setShowAboutModal] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      getAccessTokenSilently().then((token) => setAccessToken(token));
    }
  }, [getAccessTokenSilently, isAuthenticated]);

  useEffect(() => {
    getAbout(accessToken).then((res) => {
      setXml(res);
    });
  }, [showAboutModal, accessToken]); // Added accessToken dependency

  useEffect(() => {
    if (accessToken) {
      getUsersAdmin(accessToken).then((res) => { setIsAdmin(res) });
    }
  }, [accessToken]);

  if (isLoading || !xml) {
    return <Loading/>
  }

  const xmlDoc = new DOMParser().parseFromString(xml, "text/xml");
  const papersList = Array.prototype.slice.call(xmlDoc.getElementsByTagName("paper"));

  return (
    <span>
      <AboutModal
        open={showAboutModal}
        xml={xml}
        accessToken={accessToken}
        onClose={() => setShowAboutModal(false)}
      />
      {papersList.map((paper, key) => (
        <Paper key={key} elevation={4} style={{padding: 20, marginBottom: 10}}>
          <Typography variant="h5">
            {paper.childNodes[0].textContent}
          </Typography>
          <Typography>
            {paper.childNodes[1].textContent}
          </Typography>
        </Paper>
      ))}
      {isAdmin && <Button onClick={() => setShowAboutModal(true)} color="primary"><Create /> Edit</Button>}
    </span>
  )
}

export default About;